<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商库存估算</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择设备类型" class="select2">
              <el-option label="请选择设备类型" value="-1"></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
<!--        <div>
          总订购量：{{NumTotalDingGou}}
        </div>
        <div>
          总销售量：{{NumTotalXiaoShou}}
        </div>
        <div>
          总库存量：{{NumTotalKuCun}}
        </div> -->
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataListMix" :row-class-name="tableRowClassName" border stripe>
          <el-table-column prop="Jigouname" label="机构名称" min-width="6%"></el-table-column>
          <el-table-column prop="NumQiChu" label="期初" min-width="6%"></el-table-column>
          <el-table-column prop="NumDingGou" min-width="6%">
            <template slot="header">
              <span @click="clickdinggou">订购量</span>
            </template>
          </el-table-column>
          <el-table-column prop="NumXiaoShou" min-width="6%">
            <template slot="header">
              <span @click="clickxiaoshou">销售量</span>
            </template>
          </el-table-column>
          <el-table-column prop="NumKuCun" min-width="6%">
            <template slot="header">
              <span @click="clickkucun">库存量</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyErpDlsKucun',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [
        { value: '103-0000-0004', label: 'RSL-5.0' },
        { value: '103-0000-0003', label: 'RSL-6.0' },
        { value: '103-0000-0002', label: 'RSL-6.0T' },
        { value: '103-0000-0001', label: 'RSL-Mini' }
      ],
      // 查询
      keywords: {
        bomsn: '103-0000-0002',
        begintime: '',
        endtime: '',
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListMix: [],
      NumTotalDingGou: 0,
      NumTotalXiaoShou: 0,
      NumTotalKuCun: 0,
      sortdinggou: false,
      sortxiaoshou: false,
      sortkucun: false
    }
  },
  mounted () {
    // this.apiGetWorkprojectList()
    this.apiGetYunYingShangKuCun()
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'firstline'
      }
      return ''
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clicksearch () {
      this.apiGetYunYingShangKuCun()
    },
    clickdinggou () {
      var that = this
      that.sortdinggou = !that.sortdinggou
      that.dataList.sort(function (a, b) {
        var x = a.NumDingGou
        var y = b.NumDingGou
        if (that.sortdinggou) {
          x = b.NumDingGou
          y = a.NumDingGou
        }
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })
      this.getdataListMix()
    },
    clickxiaoshou () {
      var that = this
      that.sortxiaoshou = !that.sortxiaoshou
      that.dataList.sort(function (a, b) {
        var x = a.NumXiaoShou
        var y = b.NumXiaoShou
        if (that.sortxiaoshou) {
          x = b.NumXiaoShou
          y = a.NumXiaoShou
        }
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })
      this.getdataListMix()
    },
    clickkucun () {
      var that = this
      that.sortkucun = !that.sortkucun
      that.dataList.sort(function (a, b) {
        var x = a.NumKuCun
        var y = b.NumKuCun
        if (that.sortkucun) {
          x = b.NumKuCun
          y = a.NumKuCun
        }
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })
      this.getdataListMix()
    },
    getdataListMix () {
      this.dataListMix = []
      this.dataListMix.push({
        Jigouid: 0,
        Jigouname: '合计',
        NumQiChu: this.NumTotalKuCun - this.NumTotalDingGou + this.NumTotalXiaoShou,
        NumDingGou: this.NumTotalDingGou,
        NumXiaoShou: this.NumTotalXiaoShou,
        NumKuCun: this.NumTotalKuCun
      })
      this.dataListMix.push.apply(this.dataListMix, this.dataList)
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype === 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetYunYingShangKuCun: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      that.dataList = []
      that.dataListMix = []
      that.NumTotalDingGou = 0
      that.NumTotalXiaoShou = 0
      that.NumTotalKuCun = 0
      axios.post(Vue.prototype.global.Url_GetYunYingShangKuCun, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.NumTotalDingGou = response.data.NumTotalDingGou
            that.NumTotalXiaoShou = response.data.NumTotalXiaoShou
            that.NumTotalKuCun = response.data.NumTotalKuCun
            that.getdataListMix()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
